import { Typography } from "@mui/material";
import { ArrowDropUp, Remove } from "@mui/icons-material";
import theme from "theme";
import { Card, Row } from "v2/components/base/Flex/ui";

export const PercentageBlock = ({
  averageToFormat,
  bgColor,
  value,
  arrowDirection,
  ...props
}: {
  averageToFormat: number;
  bgColor: string;
  value: string;
  arrowDirection: "up" | "down" | "none";
} & Record<string, any>) => {
  const { sx, ...rest } = props;

  return (
    <Card.Badge
      sx={{
        color:
          averageToFormat === 0
            ? theme.palette.surface["silver"]
            : averageToFormat > 0
            ? theme.palette.system["green-alarm"]
            : theme.palette.system["red-alarm"],
        bgcolor: theme.palette.surface["container-bg"],
        border: `1px solid ${theme.palette.border.light}`,
        width: "fit-content",
        ...sx,
      }}
      {...rest}>
      <Row
        type="ec"
        sx={{
          position: "relative",
          minWidth: "52px",
          padding: "2px 2px",
        }}>
        {arrowDirection === "none" ? (
          <Remove
            sx={{
              position: "absolute",
              left: theme.spacing(-0.75),
              width: "12px",
              marginLeft: "4px",
            }}
          />
        ) : (
          <ArrowDropUp
            sx={{
              position: "absolute",
              left: theme.spacing(-0.75),
              transform: arrowDirection === "down" ? "rotate(180deg)" : "none",
            }}
          />
        )}
        <Typography
          variant="mobile-body-s-heavy"
          marginLeft={averageToFormat !== 0 ? theme.spacing(2) : 0}>
          {value}%
        </Typography>
      </Row>
    </Card.Badge>
  );
};

export default PercentageBlock;
